import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Works from "@/pages/works/page";
import WorkDetail from "@/pages/works/detail/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import About from "@/pages/about/page";
import SearchPage from "@/pages/search/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "works", element: <Works /> },
      { path: "works/:id", element: <WorkDetail /> },
      { path: "news", element: <News /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "about", element: <About /> },
      { path: "search", element: <SearchPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;